import { compact } from 'lodash'

/**
 * selectedTipOption - yup validation
 *
 * @description - selected tip option is required when value is undefined which means user has not selected any option
 *
 * @param {string} value - selected tip option
 *
 */
const selectedTipOption = (value) => {
  if (value === undefined) {
    return false
  }

  return true
}

/**
 * tipValues - yup validation
 *
 * @description - check if tip values are unique
 *
 * @param {array} tipValues - array of tip values
 */

const tipValues = (tipValues) => {
  const tipValuesWithoutNull = compact(tipValues)

  return (
    new Set(tipValuesWithoutNull).size === tipValuesWithoutNull.length
  )
}

const venueSettingsValidation = {
  selectedTipOption,
  tipValues,
}

export default venueSettingsValidation
